import React, { useReducer, useEffect, useContext } from "react";
import moduleConfig from "./moduleConfig"
import { Card, Row, Col } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from "formik"

import * as yup from "yup"
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import axios from "../../../config/axios";
import { createReducer, createInitialState } from "./reducers/createReducer"
import { BreadcrumbContext } from '../../../contexts/BreadcrumbContext';
import { Store as toast } from 'react-notifications-component';
import { toastNotification } from '../../../config/toastNotification'
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleCreateView from "../../UI/modules/views/ModuleCreateView";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSFormController from "../../UI/forms/CMSFormController";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import CMSRichTextEditor from "../../UI/forms/CMSRichTextEditor";
import CMSFormDate from "../../UI/forms/CMSFormDate";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import CMSFormRichText from "../../UI/forms/CMSFormRichText";
import CMSFormCheckBoxes from "../../UI/forms/CMSFormCheckBoxes";


let breadcrumbs = {
    listing: {
        label: moduleConfig.title,
        url: `/${moduleConfig.url}`
    },
    create: {
        label: "Create",
    }
};


const PartnerCreate = () => {

    const [createState, createDispatch] = useReducer(createReducer, createInitialState)
    const { setBreadcrumb } = useContext(BreadcrumbContext);
    let navigate = useNavigate();
    const onSubmit = async (data) => {
        createDispatch({
            type: "FORM_SUBMISSION_REQUEST"
        });


        try {
            const res = await axios.post(`${moduleConfig.url}`, data)//
            console.log(res);
            createDispatch({
                type: "FORM_SUBMISSION_SUCCESS",
                payload: res.data
            });

            navigate(`/${moduleConfig.url}`)
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `${moduleConfig.singleItemTitle} created successfully.`,
                type: "success",
            });
        } catch (error) {

            console.log(error.response);
            const status = error.response ? error.response.status : 500;
            const errorMessage = (status === 400) ? error.response.data.message : error.message

            createDispatch({
                type: "FORM_SUBMISSION_FAILURE",
                payload: errorMessage
            });
            setTimeout(() => {
                createDispatch({
                    type: "FORM_INITIAL_STATE"
                });
            }, 5000)
        }
    }

    useEffect(() => {
        ///  loadData()
        setBreadcrumb([
            breadcrumbs.listing,
            breadcrumbs.create
        ])

        createDispatch({
            type: "FETCH_SUCCESS",
            payload: []
        });
    }, [])


    let logoImageRequirement = {
        dimension: {
            width: 1366,
            height: 500,
        },
        allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
        size: 1024 * 1024 * 2,
    };
    let promoBannerRequirement = {
        dimension: {
            width: 500,
            height: 500,
        },
        allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
        size: 1024 * 1024 * 2,
    };
    let bannerImageRequirement = {
        dimension: {
            width: 1200,
            height: 630,
        },
        allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
        size: 1024 * 1024 * 3,
    };
    return (<DashboardLayout >


        {
            (createState.status === 'fetchFailed')
                ? <BlockErrorMessage error={createState.error} />
                : <>
                    {/* {console.log(createState.data)} */}
                    {(createState.status !== 'fetching') && <>
                        <ModuleHeader
                            moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                            moduleUrl={moduleConfig.url}
                        >
                        </ModuleHeader>

                        <section className="content">
                            <Card>
                                <Card.Body>
                                    {(createState.isLoading) && <div class="overlay position-absolute containerLoading">
                                        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                                    </div>}
                                    <Formik
                                        initialValues={{
                                            title: "",
                                            phone: '',
                                            email: '',
                                            contactUsMessage: '',
                                            website: "",
                                            websiteButtonText: '',
                                            logo: "",
                                            banner: "",
                                            heading1: "",
                                            content1: "",
                                            content2: "",
                                            content2: "",
                                            content3: "",
                                            content3: "",
                                            isPromoted: false,
                                            promotionBanner: '',
                                            promotionMessage: '',
                                            // content4: "",
                                            // content4: "",
                                            // content5: "",
                                            // content5: "",
                                            numberOfDaysToShow: 5,
                                            numberOfTimesToShowInADay: 3,
                                            sortOrder: 99,
                                            status: "0",
                                        }
                                        }
                                        validationSchema={yup.object({
                                            title: yup.string().nullable().when("logo", {
                                                is: (logo) => !logo,
                                                then: yup.string().required("Title or logo is required."),
                                            }),
                                            logo: yup
                                                .mixed()
                                                .imageTypeCheck(logoImageRequirement.allowedExtensions)
                                                .imageSizeCheck(logoImageRequirement.size),

                                            banner: yup
                                                .mixed()
                                                .imageTypeCheck(bannerImageRequirement.allowedExtensions)
                                                .imageSizeCheck(bannerImageRequirement.size)
                                                .imageDimensionCheck(bannerImageRequirement.dimension),
                                            promotionBanner: yup
                                                .mixed()
                                                .imageTypeCheck(promoBannerRequirement.allowedExtensions)
                                                .imageSizeCheck(promoBannerRequirement.size)
                                                .imageExactDimensionCheck(promoBannerRequirement.dimension).when("isPromoted", {
                                                    is: (isPromoted) => isPromoted === true,
                                                    then: yup
                                                        .mixed()
                                                        .imageTypeCheck(promoBannerRequirement.allowedExtensions)
                                                        .imageSizeCheck(promoBannerRequirement.size)
                                                        .imageExactDimensionCheck(promoBannerRequirement.dimension).required("Promotional banner is required."),
                                                }),
                                            isPromoted: yup.boolean(),
                                            phone: yup.string(),
                                            email: yup.string().email('invalid email'),
                                            contactUsMessage: yup.string(),
                                            websiteButtonText: yup.string(),
                                            website: yup.string().url(),
                                            heading1: yup.string(),
                                            content1: yup.string().required("Required"),

                                            heading2: yup.string(),
                                            content2: yup.string(),

                                            heading3: yup.string(),
                                            content3: yup.string(),
                                            promotionMessage: yup.string().max(60),
                                            heading4: yup.string(),
                                            content4: yup.string(),

                                            heading5: yup.string(),
                                            content5: yup.string(),

                                            numberOfDaysToShow: yup.number().when("isPromoted", {
                                                is: (isPromoted) => isPromoted === true,
                                                then: yup.number().required("Required."),
                                            }),
                                            numberOfTimesToShowInADay: yup.number().when("isPromoted", {
                                                is: (isPromoted) => isPromoted === true,
                                                then: yup.number().required("Required."),
                                            }),
                                            sortOrder: yup.number().required("Required"),
                                            status: yup.string().required("Required"),
                                        })
                                        }
                                        enableReinitialize={true}
                                        validateOnChange={true}
                                        validateOnBlur={true}
                                        onSubmit={async (values) => {
                                            if (values.isPromoted === true) {
                                                values.isPromoted = "1"
                                            }
                                            if (values.isPromoted === false) {
                                                values.isPromoted = "0"
                                            }
                                            const formData = new FormData();
                                            for (let name in values) {
                                                if (Array.isArray(values[name])) {
                                                    formData.append(name, JSON.stringify(values[name]));
                                                } else {
                                                    formData.append(name, values[name]);
                                                }
                                            }
                                            console.log(formData);
                                            onSubmit(formData);
                                        }}
                                    >

                                        {(form) => (
                                            <Form onSubmit={form.handleSubmit}>

                                                {(createState.error) &&
                                                    <FormErrorMessage error={createState.error} />
                                                }

                                                {/* {console.log(form.errors)} */}
                                                <CMSFormInput name="title" label="Title" required={false} form={form} />
                                                
                                                <CMSFormImageWithCrop
                                                    label="Logo"
                                                    name="logo"
                                                    required={false}
                                                    form={form}
                                                    aspect={1 / 1}
                                                    outputSize={logoImageRequirement.dimension}
                                                />

                                                <CMSFormImageWithCrop
                                                    label="Banner"
                                                    name="banner"
                                                    required={false}
                                                    form={form}
                                                    aspect={16 / 9}
                                                    outputSize={bannerImageRequirement.dimension}
                                                />

                                                <CMSFormInput name="heading1" label="Short Description" required={false} form={form} />

                                                <CMSFormRichText name="content1" label="Description" form={form} required={true} />

                                                <CMSFormInput name="contactUsMessage" label="Contact Us Section Heading" required={false} form={form} />
                                                <CMSFormInput
                                                    name="phone"
                                                    label="Phone"
                                                    form={form}
                                                />
                                                <CMSFormInput name="email" label="Email" required={false} form={form} />

                                                <CMSFormInput name="website" label="Website" type="url" required={false} form={form} />


                                                <CMSFormInput name="websiteButtonText" label="Website Button Text" required={false} form={form} />






                                                {/* <CMSFormInput name="heading2" label="Heading 2" required={false} form={form} />

                                                <CMSFormRichText name="content2" label="Content 2" form={form} />

                                                <CMSFormInput name="heading3" label="Heading 3" required={false} form={form} />

                                                <CMSFormRichText name="content3" label="Content 3" form={form} /> */}
                                                <Row className="m-0 p-0 mt-2">
                                                    <Col className="m-0 mb-3">
                                                        <input
                                                            className="selectAll"
                                                            type="checkbox"
                                                            name="isPromoted"
                                                            id="isPromoted"
                                                            onChange={(e) => form.setFieldValue('isPromoted', e.target.checked)}
                                                            checked={form.values.isPromoted}
                                                        />
                                                        <label
                                                            for="isPromoted"
                                                            className="m-0 p-0 ml-2"
                                                        >
                                                            Include Promotional Banner
                                                        </label>
                                                    </Col>
                                                </Row>


                                                {console.log("form.values.isPromoted", form.values.isPromoted)}
                                                {form.values.isPromoted === true && <>
                                                    <CMSFormImageWithCrop
                                                        label="Promotion Banner"
                                                        name="promotionBanner"
                                                        form={form}
                                                        aspect={500 / 500}
                                                        outputSize={promoBannerRequirement.dimension}
                                                    />
                                                    <CMSFormInput name="promotionMessage" label="Promotion Message" required={false} form={form} />

                                                    <CMSFormInput type="number" name="numberOfDaysToShow" label="Number Of Days To Show" required={true} form={form} />
                                                    <CMSFormInput type="number" name="numberOfTimesToShowInADay" label="Number Of Times To Show In A Day" required={true} form={form} />
                                                </>}


                                                {/* <CMSFormInput name="heading4" label="Heading 4" required={false} form={form} />

                                                <CMSRichTextEditor name="content4" label="Content 4" form={form} />

                                                <CMSFormInput name="heading5" label="Heading 5" required={false} form={form} />

                                                <CMSRichTextEditor name="content5" label="Content 5" form={form} /> */}




                                                <CMSFormInput type="number" name="sortOrder" label="Sort Order" required={false} form={form} />


                                                <CMSFormSelect name="status" label="Status" required={true} form={form} options={[{ label: "Select Status...", value: "" }, { label: "Enabled", value: "1" }, { label: "Disabled", value: "0" }]} />










                                                <button type="submit" className="btn btn-primary">Submit</button>
                                            </Form>
                                        )}
                                    </Formik>




                                </Card.Body>
                            </Card>
                        </section>
                    </>}



                </>
        }





    </DashboardLayout >);
}

export default PartnerCreate;
